export default __webpack_public_path__ + "static/media/sort-option.4adf6ec9.svg";